import { Error } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

type SettingsVerificationTechnicalFailureProps = {
  action: ReactNode;
};

function SettingsVerificationTechnicalFailure({ action }: SettingsVerificationTechnicalFailureProps) {
  const t = useTranslations('my_account.settings.verification_technical_failure');

  return (
    <div className="flex flex-col h-full" data-testid="verification-technical-failure">
      <div className="md:mt-6 text-left">
        <Error size="extra-extra-large" className="mb-5" data-testid="verification-technical-failure-icon" />
        <h4 className="mb-2 text-pretty" data-testid="verification-technical-failure-title">
          {t('title')}
        </h4>
        <p className="paragraph-explanatory text-foreground-subtle" data-testid="verification-technical-failure-description">
          {t('description')}
        </p>
      </div>
      <div className="text-center mt-auto md:mt-8" data-track-container="Actions">
        {action}
      </div>
    </div>
  );
}

export { SettingsVerificationTechnicalFailure };
